import axios from 'axios';
import Cookies from 'universal-cookie';
import { apiRouter, applicationJson } from '../constant';

let hasTokenRefreshInProgress = false;
let refreshSubscribers: Array<any> = [];
const cookies = new Cookies();

export const getAuthToken = (): Promise<string> => {
  const token = cookies.get('token');

  if (token) {
    if (hasTokenRefreshInProgress) {
      return refreshAuthToken();
    } else {
      return Promise.resolve(token);
    }
  } else {
    logout();
    return Promise.reject('No token found.');
  }
};

export const refreshAuthToken = async (): Promise<string> => {
  const token = cookies.get('token');
  if (canRefresh(token)) {
    if (hasTokenRefreshInProgress) {
      return new Promise((resolve, reject) => {
        refreshSubscribers.push({ resolve, reject });
      });
    }

    hasTokenRefreshInProgress = true;

    try {
      const newAuthToken = await getNewToken();

      refreshSubscribers.forEach(subscriber =>
        subscriber.resolve(newAuthToken),
      );
      refreshSubscribers = [];

      return newAuthToken;
    } catch (error) {
      refreshSubscribers.forEach(subscriber => subscriber.reject(error));
      refreshSubscribers = [];
      logout();
      return Promise.reject('Refresh token failed');
    } finally {
      hasTokenRefreshInProgress = false;
    }
  }

  return Promise.reject('Please login again.');
};

const getNewToken = async (): Promise<string> => {
  const token = cookies.get('token');

  const response = await axios
    .post(`${apiRouter.APIURL}/Users/refresh`, `"${token}"`, {
      headers: {
        Accept: '*/*',
        'Content-Type': applicationJson,
      },
    })
    .catch(() => Promise.reject('Refresh token failed'));

  if (response.data != null) {
    const newToken = response.data.customers[0].authToken;

    if (newToken) {
      cookies.set('userdetails', `${JSON.stringify(response.data)}`);
      cookies.set('token', newToken);
      return newToken;
    } else {
      return Promise.reject('Refresh token failed');
    }
  } else {
    return Promise.reject('Refresh token failed');
  }
};

const isTokenExpired = (token: string): boolean => {
  if (!token) {
    return true;
  }
  try {
    const payload = JSON.parse(atob(token.split('.')[1])); // Decode JWT payload
    const expirationTime = payload.exp * 1000; // Convert exp to milliseconds
    return expirationTime < Date.now();
  } catch {
    return true;
  }
};

const canRefresh = (token: string): boolean => {
  const userDetails = cookies.get('userdetails');
  //Refresh if the token is expired and if the backend has said this can be refreshed
  return isTokenExpired(token) && userDetails?.canRefresh === true;
};

export const logout = (): void => {
  cookies.remove('token');
  cookies.remove('userdetails');
  localStorage.removeItem('selectedChecklists');
};
